<template>
  <div class="bg-surface rounded-lg">
    <Icon :icon="contentIcon" :size="props.size" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ContentType } from '~/api/contents';
import { Icon, IconSize } from '@/components/icon';
import ContentResourceSvg from '@/assets/icons/content-resource.svg?component';
import ContentSocialsSvg from '@/assets/icons/content-socials.svg?component';
import ContentFilesSvg from '@/assets/icons/content-files.svg?component';

type Props = {
  contentType: ContentType;
  size?: IconSize;
};
const props = withDefaults(defineProps<Props>(), {
  size: IconSize.MD,
});

const contentTypeIconMap = {
  [ContentType.RESOURCE]: ContentResourceSvg,
  [ContentType.SOCIALS]: ContentSocialsSvg,
  [ContentType.FILES]: ContentFilesSvg,
};
const contentIcon = computed(() => {
  return contentTypeIconMap[props.contentType];
});
</script>
